<template>
  <div class="white_bg">
    <article v-html="agreement" class="article agreementArticle paddingV18 paddingH12"> </article>
  </div>
</template>

<script>
import agreementApi from "@comp/help/agreementApi";

export default {
  name: "agreement",
  data(){
    return{
      agreement:'',
    }
  },
  mounted() {
    const type = this.$route.params.type
    this.getInfo(type)
  },
  methods: {
    getInfo(type) {
      agreementApi.getTypeList(type,(result)=>{
        this.agreement = result
      })
    }
  }
}
</script>

<style scoped>

</style>